function injectStyle (ssrContext) {
  require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-7725d48c\",\"scoped\":false,\"hasInlineConfig\":false}!less-loader?sourceMap!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./reg-flows.vue")
}
var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-7725d48c\",\"hasScoped\":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./reg-flows.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/reg-flows.vue
// module id = 702
// module chunks = 7 8